export default function primeiraPagina() {
  return "/pesquisa";
}
